import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import type { IProduct } from '@inter-ikea-kompis/types';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

import RepairabilityIndexUtility from '../../utilities/RepairabilityIndexUtility.js';
import RepairabilityIndexCardStyle from './RepairabilityIndexCardStyle.js';

export default class RepairabilityIndexCard extends KompisElement {
	// A product.
	@property({ type: Object, required: true })
	public product!: IProduct;

	public override render(): RenderResult {
		return html`
			<style>
				${RepairabilityIndexCardStyle.getStyle()}
			</style>

			${this.getRepairabilityIndexDocument()}
		`;
	}

	private getRepairabilityIndexDocument(): RenderResult {
		// The PDF version is lower file size, but using PDF requires an iframe (or some other solution) which is why the image file formats are used instead.
		const documentUrl =
			RepairabilityIndexUtility.getDocumentUrl(this.product, 'svg') ??
			RepairabilityIndexUtility.getDocumentUrl(this.product, 'png');

		if (!documentUrl) {
			return null;
		}

		return html`<img
			src="${documentUrl}"
			alt="${RepairabilityIndexUtility.getImageAltText(this.product)}"
		/>`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'kompis-repairability-index-card': RepairabilityIndexCard;
	}
}
